<app-modal class="lifecycle-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.toolBackupsModal.title' | translate }}</h5>
    </ng-container>
    <div class="body" modal-body>
        <app-tool-backup-table
            [isMaterial]="false"
            [isLoading] = "loading"
            [toolBackups]="toolBackups"
            [tableConfig]="tableConfig"
            (checkedTools)="onCheckedTools($event)">
        </app-tool-backup-table>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="loading"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="loading"
                    (click)="onSave()">{{ 'generic.buttons.save' | translate }}
        </app-button>

    </div>
</app-modal>
